// 📫 TypeScript notice!
//
// Text keys in the "texts" object are automatically typed to the IntlMessageKeys TypeScript Interface.
// If you are adding more languages, also add the language key like documented in frontend/src/i18n/Intl.tsx.
//
// TypeScript will throw a compiling error if two languages does not contain all, and equal keys.

export const fallbackTexts = {
  nb: {
    // Feilkoder
    "feilmelding.400_header":
      "Vi fikk et problem med å behandle forespørselen.",
    "feilmelding.content":
      "Dersom problemet vedvarer, ta kontakt med brukerstøtte på support@landbruksdirektoratet.no og oppgi følgende feilkode: {feilkode}",
    "feilmelding.404_header": "Siden finnes ikke.",
    "feilmelding.404_backend-header": "Vi finner ikke siden.",
    "feilmelding.404_backend-header-uuid":
      "Vi finner ikke siden. Feilkode: {feilkode}",
    "feilmelding.403_header":
      "Du har ikke tilgang til denne siden. Feilkode: {feilkode}",
    "feilmelding.500_header": "En feil har oppstått.",
  },
};
